const PRIMARY_COLOR = '#FC4B58';
const PRIMARY_COLOR_LIGHT_ONE = '#ffeaea';
const PRIMARY_COLOR_LIGHT_TWO = '#FFFAF9';
const SECONDARY_COLOR = '#ffd670';

const getDesignTokens = (mode) => ({
	breakpoints: {
		values: {
			xs: 0,
			sm: 480,
			md: 768,
			lg: 1024,
			xl: 1400
		}
	},
	typography: {
		htmlFontSize: 10,
		fontFamily: "'Poppins', sans-serif;"
	},
	palette: {
		mode,
		common: {
			white: '#ffffff',
			black: '#000000'
		},
		...(mode === 'light'
			? {
					primary: {
						main: PRIMARY_COLOR,
						lightOne: PRIMARY_COLOR_LIGHT_ONE,
						lightTwo: PRIMARY_COLOR_LIGHT_TWO,
						contrastText: '#fff',
						grey: '#909497'
					},
					secondary: {
						main: '#D7DBDD',
						contrastText: '#030303',
						grey: '#e9e9e9 '
					},
					text: {
						primary: '#000',
						secondary: '#555'
					},
					divider: PRIMARY_COLOR,
					background: {
						default: '#fff'
					}
			  }
			: {
					primary: {
						main: SECONDARY_COLOR,
						contrastText: '#000',
						grey: '#bab5b5'
					},
					text: {
						primary: '#fff',
						secondary: '#ddd'
					},
					divider: SECONDARY_COLOR,
					background: {
						default: '#111',
						paper: '#111'
					}
			  })
	}
});

export default getDesignTokens;
